import useForgeRock from "hooks/useForgeRock";
import { useState, useEffect } from "react";
import { getUserDetails } from "services/apis";
import { mongoUser, MongoUserResponse } from "types/User/MongoUser";
import { appInsights } from "../../../ApplicationInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

const useGetMongoUser = () => {
  const { APICall } = useForgeRock();
  const [mongoUser, setMongoUser] = useState<mongoUser>({
    userId: "",
    phoneNumber: "",
    jobTitle: "",
  });
  useEffect(() => {
    const getMongoData = async () => {
      try {
        const result: MongoUserResponse = await APICall({ ...getUserDetails() });
        if (result.resultCode === 0 && result.response) {
          return setMongoUser(result.response);
        }
        throw new Error("Failed to retrieve user details");
      } catch (error) {
        appInsights.trackException({
          error: error as Error,
          severityLevel: SeverityLevel.Error,
        });
        setMongoUser({ userId: "", phoneNumber: "", jobTitle: "" });
      }
    };
    getMongoData();
  }, []);

  return { mongoUser };
};

export default useGetMongoUser;
